import { IdentifiedPaymentOrder } from "@backbase/data-ang/payment-order"

export enum PaymentType {
  BANESCO_CC_PAYMENT = 'BANESCO_CC_PAYMENT',
  BANESCO_LOAN_PAYMENT = 'BANESCO_LOAN_PAYMENT',
  WITHIN_BANK_TRANSFER = 'WITHIN_BANK_TRANSFER',
  BANESCO_CC_PAYMENT_OTP = 'BANESCO_CC_PAYMENT_OTP',
  WITHIN_BANK_TRANSFER_OTP = 'WITHIN_BANK_TRANSF_OTP',
  BANESCO_LOAN_PAYMENT_OTP = 'BANESCO_LOAN_PAYMENT_OTP',
  BANESCO_STOCK_TRANSFER = 'BNSC_BSS_STOCK_TRANSFE',
  INTERNATIONAL_TRANSFER = 'BNSC_BSS_INTERN_TRANSF',
  BNSC_BSS_TAXES_TRANSF = 'BNSC_BSS_TAXES_TRANSF',
  SERVICE_TRANSFERS = 'BNSC_BSS_SERVIC_TRANSF',
  BANESCO_OTHER_BANKS = 'BNSC_BSS_W_BANK_TRANSF',
  BNSC_BSS_PAYMENT_PAYROLL = 'BNSC_BSS_PAYMENT_PAYROLL_MANUAL',
}

export interface PaymentEvent {
  action: OpenPaymentAction,
  payment: IdentifiedPaymentOrder
}

export enum OpenPaymentAction {
  EDIT,
  DUPLICATE
}